export default function CubeSolidIcon({
  ...props
}: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 20 20"
      fill="none"
      {...props}
    >
      <path
        fill="currentColor"
        d="M11 16.998a1 1 0 0 0 1.447.895l4-2a1 1 0 0 0 .553-.895V9.234a1 1 0 0 0-1.447-.894l-4 2a1 1 0 0 0-.553.894v5.764ZM15.21 6.276a1 1 0 0 0 0-1.788l-4.763-2.382a1 1 0 0 0-.894 0L4.789 4.488a1 1 0 0 0 0 1.788l4.764 2.382a1 1 0 0 0 .894 0l4.764-2.382ZM4.447 8.34A1 1 0 0 0 3 9.234v5.764a1 1 0 0 0 .553.895l4 2A1 1 0 0 0 9 16.998v-5.764a1 1 0 0 0-.553-.894l-4-2Z"
      />
    </svg>
  );
}
